import type { C1_FurnitureDefinition, C1_FurnitureRendererProps } from "../../types/C1_FurnitureTypes";
import { RoomType } from "../../types/C1_ModelTypes";
import { C1_FurnitureSvg } from "../C1_FurnitureSvg";
import { C1_FurnitureIcon } from "../C1_FurnitureIcon";

const DEFAULT_WIDTH = 0.9;
const DEFAULT_HEIGHT = 0.9;
const WALL_GAP_M = 0.1;

const Armchair: C1_FurnitureDefinition = {
  id: "armchair",
  icon: <C1_FurnitureIcon kind="armchair" />,
  description: { en: "Armchair", de: "Sessel" },
  category: RoomType.Living,
  defaultWidth: DEFAULT_WIDTH,
  defaultHeight: DEFAULT_HEIGHT,
  originXPercentage: 50,
  originYPercentage: 0,
  wallDockable: true,
  autoRotate: true,
  properties: [],
  Renderer: ({
    width,
    height,
    rotation,
    PX,
    strokeWidth,
    strokeColor,
    fillColor,
  }: C1_FurnitureRendererProps) => {
    const finalRotation = rotation ?? 0;
    const finalStrokeWidth = strokeWidth ?? 2;
    const finalStrokeColor = strokeColor ?? "#000000";
    const finalFillColor = fillColor ?? "#ffffff";
    const backrestThickness = 14;
    const armrestThickness = backrestThickness;
    const geometryOffsetY = WALL_GAP_M * PX;
    const seatX = armrestThickness;
    const seatY = backrestThickness;
    const seatWidth = Math.max(0, width - armrestThickness * 2);
    const seatHeight = Math.max(0, height - backrestThickness);
    const cornerRadius = Math.min(12, armrestThickness / 2, backrestThickness / 2);

    return (
      <C1_FurnitureSvg
        PX={PX}
        width={width}
        height={height}
        rotation={finalRotation}
        viewBoxWidth={width}
        viewBoxHeight={height}
        preserveAspectRatio="none"
        originXPercentage={50}
        originYPercentage={0}
      >
        <g transform={`translate(0 ${geometryOffsetY})`}>
          <rect
            x={seatX}
            y={seatY}
            width={seatWidth}
            height={seatHeight}
            rx={Math.min(8, seatWidth / 10, seatHeight / 10)}
            fill={finalFillColor}
            stroke={finalStrokeColor}
            strokeWidth={finalStrokeWidth}
          />
          <rect
            x={0}
            y={0}
            width={width}
            height={backrestThickness}
            rx={cornerRadius}
            fill={finalFillColor}
            stroke={finalStrokeColor}
            strokeWidth={finalStrokeWidth * 2}
          />
          <rect
            x={0}
            y={0}
            width={armrestThickness}
            height={height}
            rx={cornerRadius}
            fill={finalFillColor}
            stroke={finalStrokeColor}
            strokeWidth={finalStrokeWidth * 2}
          />
          <rect
            x={width - armrestThickness}
            y={0}
            width={armrestThickness}
            height={height}
            rx={cornerRadius}
            fill={finalFillColor}
            stroke={finalStrokeColor}
            strokeWidth={finalStrokeWidth * 2}
          />
        </g>
      </C1_FurnitureSvg>
    );
  },
};

export default Armchair;
